export enum SignupMethod {
  GOOGLE = 'GOOGLE',
  EMAIL = 'EMAIL',
}
